import { IValidatorFactoryService } from './validator-factory.service';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

import { IStringLengthMetadata } from 'app/extensibility/metadatas/validator/string-length-validator-metadata';
import { format } from 'app/shared/utils/string.util';

export class StringLengthValidatorFactoryService implements IValidatorFactoryService<IStringLengthMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'pattern';

    public createValidatorByMetadata(metadata: IStringLengthMetadata): IValidatorFn {
        return this.createValidator(metadata.min, metadata.max, metadata.propertyName);
    }

    public createValidator(minLength: number, maxLength: number, propertyName: string, allowEmpty?: boolean): IValidatorFn {
        const errorMessage = format(stringResources.Validator_ErrorMessage_StringLength, propertyName, minLength.toString(), maxLength.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value === undefined || value === null || !value) {
                if (allowEmpty) {
                    return null;
                }
                value = '';
            }
            const str = value as string;
            return (str.length >= minLength && str.length <= maxLength) ? null : errorMessage;
        };
    }

    // fixed message: [entityType] name has exceeded the limit of [maxLength]
    public maxLengthValidator(maxLength: number, entityType: string): IValidatorFn {
        const errorMessage = format(stringResources.Validator_NameMaxLength, entityType, maxLength.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value === undefined || value === null) {
                value = '';
            }
            const str = value as string;
            return (str.length > maxLength) ? errorMessage : null;
        };
    }

    // fixed message: [entityType] name has exceeded the limit of [maxLength]
    public minLengthValidator(minLength: number, entityType: string): IValidatorFn {
        const errorMessage = format(stringResources.Validator_NameMinLength, entityType, minLength.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (!value) {
                return null; // don't check length if field is empty.
            }
            const str = value as string;
            return (str.length < minLength) ? errorMessage : null;
        };
    }
}
